import React, { useState } from 'react';
import { IDestination } from '../../../../../../store/ducks/long-steel-shopping-cart/types';
import { Select } from '@gerdau/hefesto/Select';

interface IDestinationSelectProps {
  selectedDestination: string;
  destinations: IDestination[];
  onSelectDestination(selectedDestination: string): void;
}

const DestinationSelect: React.FC<IDestinationSelectProps> = ({
  selectedDestination,
  destinations,
  onSelectDestination
}) => {
  const [availableDestinations] = useState([
    ...destinations.map((dest) => dest.description)
  ]);

  const destionationsOptions = availableDestinations.map((dest) => ({
    label: dest,
    value: dest
  }));

  return (
    <Select
      label=""
      hideLabel
      name="destinationSelect"
      options={destionationsOptions}
      value={selectedDestination}
      onSelect={(selectedDestinationOption: unknown) =>
        onSelectDestination(selectedDestinationOption as string)
      }
    />
  );
};

export default DestinationSelect;
